import React, { useState, useEffect, useCallback } from 'react';
import Question from './Question';
import Results from './Results';
import LoadingSVG from '../img/loading.svg'
import ErrorBoundary from '../ErrorBoundary';
import { QuestionContext } from './context';

function random(min, max) { 
  return Math.floor(Math.random() * (max - min + 1) + min)
}

function shuffle(options) {
  let currentIndex = options.length, randomIndex;

  while (currentIndex !== 0) {
    randomIndex = random(0, currentIndex);
    currentIndex--;

    [options[currentIndex], options[randomIndex]] = [
      options[randomIndex], options[currentIndex]];
  }

  return options;
}

const questionTypes = ['capital', 'flag'];

function Quiz() {
  const [data, setData] = useState(null);
  const [question, setQuestion] = useState(null);
  const [gameStarted, setGameStarted] = useState(false);
  const [score, setScore] = useState(0);
  const [next, setNext] = useState('question');
  const [showAnswers, setShowAnswers] = useState(false);
  const [showResults, setShowResults] = useState(false);
  
  useEffect(() => {
    fetch('https://restcountries.com/v3.1/all').then(response => {
      return response.json();
    }).then(json => {
      setData(json);
    }).catch(error => console.error(error));    
  }, [])

  const createQuestion = () => {
    const questionType = questionTypes[random(0, 1)];
    const answerCountry = data[random(0, data.length-1)];
    let optionsCountries = [answerCountry.name.common];

    for (let i = 0; i < 3; i++) optionsCountries.push(data[random(0, data.length-1)].name.common);
    
    optionsCountries = shuffle(optionsCountries);
    optionsCountries = optionsCountries.filter(item => item !== undefined)

    const question = {
      type: questionType,
      flag: answerCountry.flags.svg,
      capital: answerCountry.capital[0],
      options: optionsCountries,
      answer: optionsCountries.indexOf(answerCountry.name.common)
    };
    setQuestion(question);
  }

  useEffect(() => {
    if (data) {
      createQuestion();
      setGameStarted(true);
    }
  }, [data]);

  const pickOption = (option) => {
    console.log(option);
    if (option === question.answer) {
      setScore(score + 1);
      setShowAnswers(true);
    } else {
      setNext('results');
      setShowAnswers(true);
    }
  }

  const handleNextButtonClick = () => {
    if (next === 'question') {
      setShowAnswers(false);
      createQuestion();
    } else if (next === 'results') {
      setShowResults(true);
    }
  }

  const tryAgain = () => {
    createQuestion();
    setShowAnswers(false);
    setScore(0);
    setNext('question')
    setShowResults(false);
  }

  return (<div className='absolute left-[50%] top-[50%] -translate-x-[50%] -translate-y-[50%]'>
    <h1 className='text-white font-bold text-3xl select-none'>COUNTRY QUIZ</h1>
    <div className='w-[350px] bg-white rounded-2xl mt-3 pb-6 sm:w-[400px]'>
      {showResults ?
      <Results correctAnswers={score} tryAgain={tryAgain} />
      :
      (<>
        {gameStarted ?
          <ErrorBoundary>
            <QuestionContext.Provider value={[pickOption, showAnswers]}>
              <Question handleNextButtonClick={handleNextButtonClick} type={question.type} capital={question.capital} flag={question.flag} options={question.options} answer={question.answer} />
            </QuestionContext.Provider>
          </ErrorBoundary>
          :
          <img src={LoadingSVG} className='w-32 mx-auto' alt='Loading...' />
        }
      </>)
      }

    </div>
  </div>);
}

export default Quiz;